<ion-header>
  <ion-toolbar>
    <ion-back-button slot="start"></ion-back-button>
    <ion-title>Collection Templates</ion-title>
    <ion-button slot="end" fill="clear" (click)="createCollectionTemplate()">
      <ion-icon name="add-outline"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher #refresher slot="fixed" (ionRefresh)="swipeToRefresh()">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div
    class="screen-tip"
    *ngIf="paginatedData.docs.length < 1">
    <img src="assets/imgs/undraw_pay_online_re_aqe6.svg"/>
    <p>Create templates to accept ids through universal QR Code</p>
    <ion-button (click)="createCollectionTemplate()">Create</ion-button>
  </div>

  <ion-list *ngIf="collectionTemplates$ | async as collectionTemplates">
    <ion-item
      class="template-name"
      button=""
      *ngFor="let template of collectionTemplates"
      (click)="viewTemplate(template)">
      <ion-label>{{ template.purpose }}</ion-label>
    </ion-item>

  </ion-list>

  <ion-infinite-scroll threshold="100px" (ionInfinite)="infiniteLoad($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
